import React, { useMemo } from 'react';
import styled from 'styled-components/macro';
import { Route, Switch } from 'react-router-dom';
import { Nav, NavPublics } from 'components/organisms';
import { useRouterContext } from 'hooks';
import { isDev } from 'services/constants'

import {
  Dashboard,
  Subweb,
  SubwebMenuEditor,
  Editor,
  Gather,
  Login,
  Profile,
  NotFound,
  UnderDevelopment,
  Gallery,
  GalleryEdit,
  GalleryUpload,
  Dummy,
  Markdown,
  Support,
  Files,
  People,
  SubwebSettings,
  Permissions,
  Admin
} from 'views';

// pages without nav
const pagesFullscreen = ['/gather', '/login'];

const Router = () => {
  const { location } = useRouterContext();
  const hasNav = useMemo(() => !pagesFullscreen.includes(location.pathname), [
    location.pathname,
  ]);

  return (
    <>
      <Bar>
        {hasNav && <NavPublics />}
      </Bar>
      <Wrapper>
        {hasNav && <Nav />}
        <Switch>
          <Route exact path="/gather" component={Gather} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/profile" component={Profile} />
          <Route exact path="/admin" component={Admin} />
          <Route
            exact
            path={[
              '/permissions',
              '/settings',
            ]}
            component={UnderDevelopment}
          />
          {isDev && <Route exact path="/dummy" component={Dummy} />}
          <Route exact path="/markdown" component={Markdown} />
          <Route exact path="/support" component={Support} />
          <Route exact path="/support/:slug" component={Support} />
          <Route exact path="/" component={Dashboard} />
          <Route exact path="/:subweb" component={Subweb} />
          <Route exact path="/:subweb/assets" component={Gallery} />
          <Route exact path="/:subweb/assets/upload" component={GalleryUpload} />
          <Route exact path="/:subweb/assets/:assetId" component={GalleryEdit} />
          <Route exact path="/:subweb/files/:lang" component={Files} />
          <Route exact path="/:subweb/files/:lang/:fileId" component={Files} />
          <Route path="/:subweb/people" component={People} />
          <Route path="/:subweb/settings" component={SubwebSettings} />
          <Route path="/:subweb/permissions" component={Permissions} />
          <Route exact path="/:subweb/editor/:lang/nav" component={SubwebMenuEditor} />
          {
            /*
              This should of been done with nested routes
              my bad :(
            */
          }
          <Route
            exact
            path={[
              '/:subweb/editor/:lang/page/:pageId',
              '/:subweb/editor/:lang/page/:pageId/diff',
              '/:subweb/editor/:lang/page/:pageId/json',
              '/:subweb/editor/:lang/page/:pageId/history',
              '/:subweb/editor/:lang/page/:pageId/permissions',
              '/:subweb/editor/:lang/page/:pageId/module/:moduleId',
              '/:subweb/editor/:lang/page/:pageId/module/:moduleId',
            ]}
            component={Editor}
          />
          <Route component={NotFound} />
        </Switch>
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  min-height: 100vh;
`;

const Bar = styled.div`
  border-bottom: ${props => props.theme.values.borderSizeM} solid
    ${props => props.theme.colors.borderLighter};
`

export default Router;
